<template>
  <section v-if="species && news.length > 0 && $_clientMode === 'normal'">
    <v-row class="mt-10">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3 class="text--secondary">Nyheter från havet.nu</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="n in news"
        :key="n.id"
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
        class="d-flex child-flex"
      >
        <v-card class="fit">
          <v-img :src="$_getImage(n.news_image_id)" max-height="150px"></v-img>
          <v-card-text class="pb-0">
            <div class="subtitle-1 text-uppercase color-primary">
              Nyhet
            </div>
          </v-card-text>
          <v-card-title>
            {{ n.news_title }}
          </v-card-title>

          <v-card-text>
            {{ n.news_preamble }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-2"
              text
              target="_blank"
              :href="'https://www.havet.nu/' + n.url"
            >
              Läs<v-icon right>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import DataLayer from '@/store/SingleSpeciesDataLayer'
import Misc from '@/mixins/Misc.js'
export default {
  name: 'SpeciesNews',
  mixins: [Misc],
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {
      news: []
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    async setup() {
      try {
        const data = await DataLayer.GetRelatedNewsBySpecName(
          this.species.name_sve
        )
        this.news = data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-1 {
  color: #7ead61;
}
</style>
